<template>
	<div class="container mt-5">

		<h1 class="title-primary">Регистрация нового пользователя</h1>

		<div v-if="userRegSuccess">
			<h3 class="text-primary mb-3">Регистрация прошла успешно</h3>

			<p><strong>Email:</strong> {{email}}</p>

			<router-link :to="{name: 'sign-in'}" class="btn btn-primary me-3">Войти на сайт</router-link>
			<router-link :to="{name: 'home'}" class="btn btn-outline-primary">На главную</router-link>
		</div>
		<div v-else>
			<div class="row">
				<div class="col-md-8 col-lg-5 col-xl-4">

					<app-form api="user/register">
						<div class="mb-4">
							<label for="sign-up-input-email">Email</label>
							<input id="sign-up-input-email" type="email" v-model="email" class="form-control">

							<ValidateErrors :errors="v$.email.$errors"/>
						</div>

						<div class="mb-4">
							<label for="sign-up-input-pass">Пароль</label>
							<div class="d-flex">
								<input id="sign-up-input-pass" :type="isPassVisible ? 'text' : 'password'" v-model="password" class="form-control">
								<button type="button" class="btn ms-1 text-end pass-visible-toggle" @click="changePassVisible">
									{{isPassVisible ? 'hide pass' : 'show pass'}}
								</button>
							</div>
							<ValidateErrors :errors="v$.password.$errors"/>
						</div>

						<div class="mb-4">
							<label>
								<input type="checkbox" class="form-check-input me-2" v-model="agree">
								<span>со всем согласен</span>
							</label>
							<ValidateErrors :errors="v$.agree.$errors"/>
						</div>

						<div class="mb-3">
							<button type="button" class="btn btn-primary" @click="register">
								<span class="button-spinner" :class="{
									'button-spinner_active': isRegistering
								}" data-text="Зарегистрироваться"/>
							</button>
						</div>

						<hr class="my-4" style="opacity: 0.1;">

						<div>
							<p>Уже зарегистрированы? <router-link :to="{name: 'sign-in'}">Войти на сайт</router-link></p>
						</div>
					</app-form>
				</div>
			</div>
		</div>


	</div>
</template>
<script>
import useVuelidate from '@vuelidate/core'
import { required, email, sameAs, minLength } from '@vuelidate/validators'
import ValidateErrors from '@/components/validate-errors'
import AppForm from '@/components/app-form'

export default {
	setup () {
		return {
			v$: useVuelidate()
		}
	},
	components: {
		'app-form': AppForm,
		ValidateErrors
	},
	data() {
		return {
			email: '',
			password: '',
			isPassVisible: false,
			agree: false,
			isRegistering: false,

			// server side validate errors
			vuelidateExternalResults: {
				email: [],
			},

			userRegSuccess: false
		}
	},
	methods: {
		async register() {

			// clear extra error
			this.vuelidateExternalResults.email = [];

			const valid = await this.v$.$validate();

			if (!valid || this.isRegistering) return false;

			// start waiting anim
			this.isRegistering = true;

			const request = new URLSearchParams();
			request.append('login', this.email);
			request.append('password', this.password);

			this.axios.post(this.appconf.apiHost + 'user/register', request)
				.then(response => {
					const data = response.data;

					if (data.error && typeof data.error === 'object' && Object.keys(data.error).length) {
						this.vuelidateExternalResults.email = Object.values(data.error);
					} else if (parseInt(data.result) === 1) {
						this.userRegSuccess = true;
					}
				})
				.catch(error => {
					this.vuelidateExternalResults.email = [error.toString()];
				})
				.then(() => {
					this.isRegistering = false;
				});
		},
		changePassVisible() {
			this.isPassVisible = !this.isPassVisible;
		}
	},
	validations() {
		return {
			email: { required, email },
			password: {
				required,
				minLength: minLength(6)
			},
			agree: {
				sameAs: sameAs(true)
			}
		}
	}
}
</script>